import $ from "@modules/jquery";

export default () => {

    let lastScrollTop = 0;

    $(window).on('scroll', function () {
        if ($(window).width() <= 1024) {
            let currentScroll = $(this).scrollTop();

            if (currentScroll > lastScrollTop && currentScroll > 30) {
                // Scroll verso il basso oltre i 30px
                $('.utility-menu-floating').addClass('scrolled');
            } else if (currentScroll < lastScrollTop) {
                // Scroll verso l'alto
                $('.utility-menu-floating').removeClass('scrolled');
            }

            lastScrollTop = currentScroll;
        }
    });

};